/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { Vimeo } from './vimeo';
import { Youtube } from './youtube';

/**
 * Export supported video providers.
 * We can override this module from project level to reduce number of supported video providers.
 */
export const providers = [Vimeo,Youtube];
